import { DestroyRef, EnvironmentInjector, inject, runInInjectionContext, Service } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';

import { Observable } from 'rxjs';

import { BarCoreService, BarInitializedHook } from '@lvflanders/bar-ng';
import { BarLayoutService } from '@lvflanders/bar-ng-ui';

import { defineAppMenu } from './define-app-menu.function';

// @deprecated Used only for legacy layout. NOTE here we do some processing needed for the container module after bar initialization for the app menu.
@Service({ autoProvided: false })
export class BarAppMenuInitHook implements BarInitializedHook {
    readonly #injector = inject(EnvironmentInjector);
    readonly #router = inject(Router);
    readonly #layoutLegacy = inject(BarLayoutService);
    readonly #coreService = inject(BarCoreService);
    readonly #destroyRef = inject(DestroyRef);

    order = 2;
    _framework = true;

    run(): void | Observable<void> {
        this.#coreService.basiscontextChanged.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(() => this.#defineAppMenu());

        this.#router.events.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((val) => {
            if (val instanceof NavigationEnd) this.#defineAppMenu();
        });

        return new Observable<void>((subscriber) => {
            // generate first time app menu on initialization
            this.#defineAppMenu();
            subscriber.next();
            subscriber.complete();
        });
    }

    #defineAppMenu() {
        runInInjectionContext(this.#injector, () => {
            const appMenu = defineAppMenu();
            this.#layoutLegacy.appMenuItems$.next(appMenu);
        });
    }
}
